<template>
  <div>
    <div class="header">
      <div class="block_left">
        <div class="svg" v-html="svg">
          <!-- <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.6667 5H8.33333C6.495 5 5 6.495 5 8.33333V31.6667C5 33.505 6.495 35 8.33333 35H31.6667C33.505 35 35 33.505 35 31.6667V8.33333C35 6.495 33.505 5 31.6667 5ZM8.33333 31.6667V8.33333H31.6667L31.67 31.6667H8.33333Z" fill="#8D909F"/>
            <path d="M13.3334 15.833C14.7141 15.833 15.8334 14.7137 15.8334 13.333C15.8334 11.9523 14.7141 10.833 13.3334 10.833C11.9527 10.833 10.8334 11.9523 10.8334 13.333C10.8334 14.7137 11.9527 15.833 13.3334 15.833Z" fill="#8D909F"/>
            <path d="M13.3334 22.5C14.7141 22.5 15.8334 21.3807 15.8334 20C15.8334 18.6193 14.7141 17.5 13.3334 17.5C11.9527 17.5 10.8334 18.6193 10.8334 20C10.8334 21.3807 11.9527 22.5 13.3334 22.5Z" fill="#8D909F"/>
            <path d="M26.6666 22.5C28.0473 22.5 29.1666 21.3807 29.1666 20C29.1666 18.6193 28.0473 17.5 26.6666 17.5C25.2859 17.5 24.1666 18.6193 24.1666 20C24.1666 21.3807 25.2859 22.5 26.6666 22.5Z" fill="#8D909F"/>
            <path d="M26.6666 29.167C28.0473 29.167 29.1666 28.0477 29.1666 26.667C29.1666 25.2863 28.0473 24.167 26.6666 24.167C25.2859 24.167 24.1666 25.2863 24.1666 26.667C24.1666 28.0477 25.2859 29.167 26.6666 29.167Z" fill="#8D909F"/>
            <path d="M13.3334 29.167C14.7141 29.167 15.8334 28.0477 15.8334 26.667C15.8334 25.2863 14.7141 24.167 13.3334 24.167C11.9527 24.167 10.8334 25.2863 10.8334 26.667C10.8334 28.0477 11.9527 29.167 13.3334 29.167Z" fill="#8D909F"/>
            <path d="M26.6666 15.833C28.0473 15.833 29.1666 14.7137 29.1666 13.333C29.1666 11.9523 28.0473 10.833 26.6666 10.833C25.2859 10.833 24.1666 11.9523 24.1666 13.333C24.1666 14.7137 25.2859 15.833 26.6666 15.833Z" fill="#8D909F"/>
          </svg> -->
        </div>
        <div class="title">
          {{lessonHeader}}
        </div>
      </div>               
    </div>
  </div>
</template>

<script>

  import {getNameCourse} from "../../../scripts/defaultFunctions";

  export default {
    props:{
      svg:{
        type: String,
        default: ""
      },
      title:{
        type: String,
        default: ""
      }
     
    },
    data(){
      return{
        lessonHeader: this.title
      }
    },
    created(){
      this.getHeader()
    },
    watch: {
      '$route'(to, from) {

        this.getHeader()    
      },
    },
    methods: {
      getHeader(){
        this.lessonHeader = this.title
        if(this.$route.params.idGroup !== undefined){
          this.lessonHeader = this.title + " по " + getNameCourse(this.$route.params.idCourse, this.$store.getters.getListCourses).declinationTitle;
        }else if(this.$route.params.idCourse !== undefined){
          this.lessonHeader = this.title + " по " + getNameCourse(this.$route.params.idCourse, this.$store.getters.getListCourses).declinationTitle;
        }
        
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

    $color_background: #F6F6FB;
    $color_Gray_1: #C5C5C9;
    $color_Gray_2: #ABABB2;
    $color_Gray_3: #EBEBEB;
    $color_Gray_4:  #F9F9F9;
    $color_Gray_5: #8D909F;
    $color_black: #333333;
    $color_purple: #8C71FE;
    $color_purple_1: #7B61EB;
    $color_purple_2: #6F57D6;
    $color_purple2: #F2F1FF;
    $color_purple3: #E2E2F6;
    $color_purple6: #B1A1F2;
    $color_red: #FF6597;
    $color_white: #FFFFFF;
    $color_cyan: #C0CADC;
    $color_cyan2: #AEBCD6;
    $color_cyan3: #D1DBED;
    $color_green: #89ce54;


    .fade-enter-active, .fade-leave-active {
        transition: opacity ease .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

.setting_groups_header{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;           
}
.block_left{
  display: flex;
  align-items: center;
}
.svg{
  display: flex;
  align-items: flex-end;
  margin-right:14px;
}
.title{
  font-family: $font_Geometria;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 35px;
  display: flex;
  align-items: flex-end;
  color: $color_black;
}
</style>